import { Component, input } from '@angular/core';
import { BaseComponent } from '@shared/classes';
import { WinCardThirdVariantConfig } from '@shared/models';
import { SafePipe, VariableReplacementPipe } from '@shared/pipes';

@Component({
  selector: 'b2c-variant3',
  styleUrl: './variant3.component.scss',
  templateUrl: './variant3.component.html',
  imports: [SafePipe, VariableReplacementPipe],
})
export class Variant3Component extends BaseComponent {
  amount = input<number>(0);
  config = input.required<WinCardThirdVariantConfig>();
}
